 export enum EtatSaisie {
SaisieEnCours = 1,
SaisieValideeParSociete = 2,
SaisieValideeParGenapi = 3,
SaisieCloturee = 4,
NC = 100,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/EtatSaisie.ts